// Ziyaretçi analizi izleyicisini rota değişimlerine bağlar (bkz. tracker.js).
// Sayfa başlığı sayfa çizildikten sonra ayarlandığı için görüntüleme kısa bir
// gecikmeyle kaydedilir.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createTracker, trackingDisabled } from "./tracker";

let tracker = null;
const getTracker = () => {
  if (tracker || trackingDisabled()) return tracker;
  tracker = createTracker();
  tracker.start();
  return tracker;
};

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const instance = getTracker();
    if (!instance) return undefined;
    const path = `${location.pathname}${location.search || ""}`;
    const timer = setTimeout(() => instance.pageview(path, document.title || ""), 300);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
